import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box
} from "@chakra-ui/react";
import React from "react";

const AccordionMain = ({ children, ...props }) => {
  return (
    <Accordion {...props} allowMultiple>
      {children}
    </Accordion>
  );
};

const AccordionItemSimple = ({ title, children }) => {
  return (
    <Accordion allowMultiple>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left">
              {title}
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>{children}</AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export { AccordionMain, AccordionItemSimple };
